import { useThumbnailCardDataList } from './useDataList';
import { texturesActions, texturesSelector } from '../redux/slicers/texturesSlicer';
import {
  getMaterialPageOptimizeApi,
  getMaterialsPageApi,
  getTexturesPageApi,
  getTexturesPageOptimizeApi,
  getUploadsPageApi,
  getUploadsPageOptimizeApi,
} from '../api/textures';
import { useUserContext } from '../contexts/UserContext';
import { uploadsPageActions, uploadsPageSelector } from '../redux/slicers/uploadsPageSlicer';
import { Recent_First_Value } from '../constants/filters';
import { dashboardTabMaterialsActions, dashboardTabMaterialsSelector } from '../redux/slicers/dashboardTabMaterialSlicer';

export const useTextures = ({
  requestParams,
  filterByKey,
  defaultBrands,
  defaultSort = Recent_First_Value, //'-created_at',
  useGlobalSearch,
  useOptimizedAPI = false,
  modelType,
} = {}) => {
  const data = useThumbnailCardDataList({
    selector: texturesSelector,
    resetAction: texturesActions.resetList,
    getAction: useOptimizedAPI ? getTexturesPageOptimizeApi : getTexturesPageApi,
    requestParams,
    filterByKey,
    defaultBrands,
    defaultSort,
    useGlobalFilter: true,
    useGlobalSearch,
    modelType,
  });

  return data;
};

export const useUploads = ({
  requestParams,
  filterByKey,
  defaultSort = Recent_First_Value,
  useGlobalSearch,
  useOptimizedAPI = false,
  modelType,
} = {}) => {
  const { currentUser } = useUserContext();
  const { organization, id } = currentUser;

  // const requestParams = useMemo(
  //   () => ({
  //     created_by: id,
  //     is_map: true,
  //   }),
  //   [id]
  // );

  return useThumbnailCardDataList({
    selector: uploadsPageSelector,
    resetAction: uploadsPageActions.resetList,
    getAction: useOptimizedAPI ? getUploadsPageOptimizeApi : getUploadsPageApi,
    requestParams,
    filterByKey,
    defaultBrands: organization,
    defaultSort,
    useGlobalFilter: true,
    useGlobalSearch,
    modelType,
  });
};

export const useDashboardTabMaterials = ({
  requestParams,
  filterByKey,
  defaultBrands,
  defaultSort = Recent_First_Value, //'-created_at',
  useGlobalSearch,
  useOptimizedAPI = false,
  modelType,
} = {}) => {
  const data = useThumbnailCardDataList({
    selector: dashboardTabMaterialsSelector,
    resetAction: dashboardTabMaterialsActions.resetList,
    getAction: useOptimizedAPI ? getMaterialPageOptimizeApi : getMaterialsPageApi,
    requestParams,
    filterByKey,
    defaultBrands,
    defaultSort,
    useGlobalFilter: true,
    useGlobalSearch,
    modelType,
  });

  return data;
};
